/** Shared visual formatting props for react-calendar instances. */
export const calendarFormatProps = {
  formatMonthYear: (_locale: string | undefined, date: Date) =>
    `${date.toLocaleString('en-US', { month: 'short' }).toUpperCase()} ${date.getFullYear()}`,
  formatMonth: (_locale: string | undefined, date: Date) =>
    date.toLocaleString('en-US', { month: 'short' }).toUpperCase(),
} as const;
